import { type SvgProps, SvgWrapper } from '../utils';

export function ChevronFirstIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M16.4697 5.46967C16.7626 5.17678 17.2374 5.17678 17.5303 5.46967C17.8232 5.76256 17.8232 6.23732 17.5303 6.53022L12.0605 11.9999L17.5303 17.4697C17.8232 17.7626 17.8232 18.2373 17.5303 18.5302C17.2374 18.8231 16.7626 18.8231 16.4697 18.5302L10.4697 12.5302C10.1768 12.2373 10.1768 11.7626 10.4697 11.4697L16.4697 5.46967Z" />
      <path d="M6.25 18V6C6.25 5.58579 6.58579 5.25 7 5.25C7.41421 5.25 7.75 5.58579 7.75 6V18C7.75 18.4142 7.41421 18.75 7 18.75C6.58579 18.75 6.25 18.4142 6.25 18Z" />
    </SvgWrapper>
  );
}
